export enum GenderColors {
  // 'male' = '#2F80ED',
  'male' = '#2d79a8',
  // 'female' = '#ED2F51',
  'female' = '#d14141',
  'none' = 'rgb(51 65 85)'
}